// Copy for the home card's About me section. Edit this, not the markup.
//
// A paragraph can be a plain string, or { wide, narrow } to say different
// things on desktop and phones. The Other projects section is hidden on
// phones for now, so only the wide copy points at it.

export const ABOUT = {
  paragraphs: [
    'Hi, I’m Michael Taciuk, a software developer in 🇨🇦',
    {
      wide: 'In my spare time I make some iOS apps. You’ll find them below, along with some other projects.',
      narrow: 'In my spare time I make some iOS apps. You’ll find them below.',
    },
  ],
  // Short lead-in shown before the links, so the address reads as a way to
  // reach me rather than a stray line of text.
  contactLead: 'email',
  links: [
    { label: 'michael@taci.uk', href: 'mailto:michael@taci.uk' },
  ],
};
